<template>
  <v-alert v-if="isInBubble" outlined color="purple" type="success" text>
    <div class="g-row">
      Den här visas som "bubbla" på startsidan.
      <v-btn text @click="onRemove">Ta bort</v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'PlaceInBubble',
  props: {
    value: { type: Object },
  },
  computed: {
    isInBubble() {
      return 'bubble' in this.value && this.value.bubble
    },
  },
  methods: {
    onRemove() {
      const payload = { ...this.value, bubble: false }
      this.$emit('input', JSON.stringify(payload))
    },
  },
}
</script>

<style lang="less" scoped>
.g-row {
  display: flex;
  justify-content: space-between;
}
</style>
